import React, { Component } from "react"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import mutator from "src/utilities/mutator"
import AddEALAList from "./AddEALAList/AddEALAList"
import EALAService from "../Utils/EALAService"
import USA from "src/utilities/States/SVG/USA"
import NormalizedReferenceDataTypes from "../Types/NormalizedReferenceDataTypes"
import "./AddEALA.css"
import { values } from "@fluentui/react"
import AddEALASuggestPromotion from "./AddEALASuggestPromotion/AddEALASuggestPromotion"
interface Props {
    manageParentState: Function
    addEALAS: Function
    AccessLevelID: number
    addBusy: boolean
}

interface State {
    areas: NormalizedReferenceDataTypes
    areasCopy: NormalizedReferenceDataTypes
    searchTerm: string
    searchBusy: boolean
}

class AddEALA extends Component<Props, State> {

    typingTimeout: any = 0

    state = {
        areas: [],
        areasCopy: [],
        searchTerm: "",
        searchBusy: false
    }

    componentDidMount(): void {
        const { getAvailableAreas } = EALAService
        const availableAreas = getAvailableAreas(this.props.AccessLevelID).sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
        this.manageState([{ key: "areas", value: availableAreas }, { key: "areasCopy", value: JSON.parse(JSON.stringify(availableAreas)) }])
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    filter = (input: string, areas: NormalizedReferenceDataTypes) => {
        let temp = []
        for (let i = 0; i < areas.length; i++) {
            let str = areas[i].text.toLowerCase()
            if (str.includes(input)) {
                temp.push(areas[i])
            }
        }
        this.manageState([{ key: "areas", value: temp }, { key: "searchBusy", value: false }])
    }

    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value.toLowerCase()
        this.manageState([{ key: "searchTerm", value: input }, { key: "searchBusy", value: true }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        //@ts-ignore
        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.filter(input, this.state.areasCopy)
            } else {
                this.manageState([{ key: "areas", value: this.state.areasCopy }, { key: "searchBusy", value: false }])
            }
        }, 500)
    }

    // getAvailableAreas = () => {
    //     const { AccessLevelID } = this.props
    //     const areas = EALAService.getNormalizedReferenceDataByAccessLevelID(AccessLevelID)
    //     const { lookupHashTableItem, getTableIdentifierByAccessLevelID } = EALAService
    //     let filtered: NormalizedReferenceDataTypes = []
    //     for (let i = 0; i < areas.length; i++) {
    //         const area = areas[i]
    //         const bucketItem = lookupHashTableItem(getTableIdentifierByAccessLevelID(AccessLevelID), area.id)
    //         const grants = bucketItem[8].grants
    //         for (let j = 0; j < grants.length; j++) {
    //             const grant = grants[j]
    //             if (grant[0] === AccessLevelID && !grant[2]) {
    //                 filtered.push(area)
    //             }
    //         }
    //     }
    //     return filtered
    // }

    render() {

        const { manageParentState, addEALAS, AccessLevelID, addBusy } = this.props
        const { areas, areasCopy, searchTerm, searchBusy } = this.state
        const { getAccessLevelByAccessLevelID, checkIfAddIsDirty, purgeAdds } = EALAService
        const accessLevelDesc = getAccessLevelByAccessLevelID(AccessLevelID).accessDesc
        const isWebAdmin = AccessLevelID === 1
        const nothingFound = areas.length === 0
        const isDirty = checkIfAddIsDirty(AccessLevelID, areasCopy)
        // const availableAreas = this.getAvailableAreas()

        // console.log("AddEALA props", this.props)
        // console.log("AddEALA state", this.state)
        // console.log("AddEALA areas", areas)
        // console.log("AddEALA isDirty", isDirty)

        return (

            <div className="AddEALA">
                <Modal
                    id="add-eala"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="lg"
                >
                    <Modal.Header>
                        <div className="AddEALAHeader">
                            <div className="AddEALAHeaderLeft">
                                {isWebAdmin && <div className="AddEALAHeaderIsWebAdmin">
                                    <p>Website administrators do not need any additional access levels.</p>
                                </div>}
                                {!isWebAdmin && <div className="AddEALAHeaderIsNotWebAdmin">
                                    <p>{accessLevelDesc}</p>
                                </div>}
                            </div>
                            {(!isWebAdmin && areasCopy.length > 0) && <div className="AddEALAHeaderRight">
                                <div className="AddEALAHeaderRightSearch">
                                    <FormControl
                                        id="add-eala-search-input"
                                        placeholder={"Search"}
                                        onChange={this.debounce}
                                        value={searchTerm || ""}
                                    />
                                </div>
                            </div>}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="AddEALAModalBody">
                            {(areasCopy.length > 0 || isWebAdmin) && <div className="AddEALAModalBodyHasAreas">
                                {(!isWebAdmin && !nothingFound) && <AddEALAList
                                    manageParentState={this.manageState}
                                    AccessLevelID={AccessLevelID}
                                    areas={areas}
                                />}
                                {(!isWebAdmin && nothingFound) && <div className="AddEALAModalBodyNothingFound">
                                    <div className="AddEALAModalBodyNothingFoundInner">
                                        <span className="AddEALAModalBodyNothingFoundErrEmoji">{`(>_<)`}</span>
                                        <p>Nothing found...</p>
                                        <Button variant="secondary" onClick={() => this.debounce({ target: { value: "" } })}>Clear search term</Button>
                                    </div>
                                </div>}
                                {isWebAdmin && <div className="AddEALAModalBodyWebAdminWrapper">
                                    {USA()}
                                </div>}
                            </div>}
                            {(areasCopy.length === 0 && !isWebAdmin) && <div className="AddEALAModalBodyHasNoAreas">
                                <AddEALASuggestPromotion
                                    AccessLevelID={AccessLevelID}
                                />
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddEALAModalFooter">
                            <div className="AddEALAModalFooterLeft">
                                <Button variant="secondary"
                                    onClick={() => {
                                        if (!isWebAdmin) {
                                            purgeAdds(AccessLevelID, areasCopy)
                                        }
                                        manageParentState([{ key: "addEala" }])
                                    }}>
                                    Back
                                </Button>
                            </div>
                            <div className="AddEALAModalFooterRight">
                                {searchBusy && <Spinner id="add-eala-search-spinner" animation="border"></Spinner>}
                                {addBusy && <Spinner id="add-eala-busy-spinner" animation="border"></Spinner>}
                                {(!isWebAdmin && areasCopy.length > 0) && <Button disabled={addBusy || searchBusy || nothingFound || !isDirty} variant="primary" onClick={() => addEALAS()}>Add</Button>}
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

export default AddEALA